exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".left[data-v-0e5e80a0] {\n  height: 1.25rem;\n  margin-left: 0.052083rem;\n  overflow-y: auto;\n}\n.node-ruleForm[data-v-0e5e80a0] {\n  border: 1PX solid #dcdfe6;\n  height: 1.458333rem;\n  padding: 0.234375rem 0 0 0.234375rem;\n}\n.form-cel[data-v-0e5e80a0] {\n  padding: 0.104167rem 0.260417rem 0 0;\n}\n.btn-right[data-v-0e5e80a0] {\n  text-align: right;\n  padding-right: 0.3125rem;\n}", ""]);

// exports
